// React libs
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Services
import DatavizService from '../Services/DatavizService';
// Hooks
import useGenericData from '../../../../Core/Data/Hooks/GenericData';
import usePoiFilters from './PoiFilters'
// Utils
import { ifDef } from '../../../../Core/Utils/Misc';
// Types
import * as CoreTypes from '../../../../Core/Data/Models/Core.type'
import * as DatavizTypes from '../Models/Dataviz.type'

const useProjectMetrics = (dateStart: string, dateEnd: string): CoreTypes.IDatavizHook => {
  // Variables
  const { t } = useTranslation(['dataviz', 'common']);
  const { data: metrics, ...props } = useGenericData(() => DatavizService.getProjectsMetrics(dateStart, dateEnd, filters))
  const { filters, ...filtersProps } = usePoiFilters('project')
  const stringFilters = useMemo(() => ifDef(filters, JSON.stringify), [filters])
  const data = useMemo(() => metrics?.map(({ total, label }: DatavizTypes.IProjectMetric) => ({
    name: label ?? t('common:forms.fields.undefined') ?? '',
    value: total,
  })) ?? [], [metrics, t])

  // Effects
  useEffect(() => {
    props.refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateStart, dateEnd, stringFilters])

  return {
    ...props,
    data,
    filter: filtersProps,
    chart: {
      title: t('dataviz:titles.projects'),
      formatter: '{b} : {d}% ({c})'
    }
  }
};

export default useProjectMetrics;
